/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 
 */
var ishided = false;

  if(localStorage.getItem('popuptime') != null){
    var curentTime = Math.floor(Date.now() / 1000);
    if(curentTime - parseInt(localStorage.getItem('popuptime')) < 600){
        var elem = document.querySelector('.modal--newsletter');
      if(elem != null){
        elem.style.display = "none";
      }
        ishided = true;
        jQuery('body').removeClass('inactive');
    }
  }


  
  myJQueryCode();

var isinserted = 0;
function myJQueryCode(){

jQuery( document ).ready(function() {
  
  
  var buttonHtml = '<button onclick="hidePopUp()"  class="pw-app-agree pw-app-modal-btn" style="min-width: 154px; margin:0px 5px; border-radius: 3px; padding: 9px 9px; font-size: 18px; font-weight: bold; color: #ffffff; background-color: #000000;">I am over 18</button>';
  var buttonHtml2 = '<button onclick="closeWebsite()"  class="pw-app-agree pw-app-modal-btn closebtn" style="min-width: 154px; margin:0px 5px; border-radius: 3px; padding: 9px 9px; font-size: 18px; font-weight: bold; color: #ffffff; background-color: #000000;">I am NOT over 18</button>';
  jQuery('.popup-newsletter').append(buttonHtml);
   jQuery('.popup-newsletter').append(buttonHtml2);
  if(ishided == false)
    jQuery('body').addClass('inactive');
  
  onLoginButtonClick();
  if( jQuery('.popup-newsletter').length == 0){
        jQuery('body').removeClass('inactive');
  }
   
});
  
  jQuery( document ).on('click', 'button', function(event){
      if(jQuery('.template-password').length > 0)
       return;
     console.log('button Clicked');
     localStorage.setItem('popuptime', Math.floor(Date.now() / 1000));
  });
  
   jQuery( document ).on('click', 'a', function(event){
       if(jQuery('.template-password').length > 0)
       return;
     if(jQuery(event.target).hasClass('closebtn'))
        return;
     
     
      if(localStorage.getItem('popuptime') != null){
         var curentTime = Math.floor(Date.now() / 1000);
         if(curentTime - parseInt(localStorage.getItem('popuptime')) < 600 ){
               console.log('Link Clicked');
               localStorage.setItem('popuptime', Math.floor(Date.now() / 1000));
         }
      }
     // localStorage.setItem('popuptime', Math.floor(Date.now() / 1000));
  });
  

//add button to the popup box
 
  if(jQuery('.modal.modal--newsletter').css('visibility') == 'visible'){
     jQuery('.modal.modal--newsletter').append('<div class="modalOverlay"></div>');
  }
 
}

function hidePopUp(){
   jQuery('.modal.modal--newsletter').fadeOut(200);
   jQuery('.modal.modal--newsletter').css('visibility', 'hidden');
   localStorage.setItem('popuptime', Math.floor(Date.now() / 1000));
   localStorage.setItem('ispopedup', 1);
   jQuery('body').removeClass('inactive');
}

function showPopup(){
   jQuery('.modal.modal--newsletter').fadeIn(200);
   jQuery('.modal.modal--newsletter').css('visibility', 'visible');
   jQuery('.modalOverlay').remove();
    jQuery('body').addClass('inactive');
}


/* Redirect to Google when I am NOT over 18 button is pressed */

function closeWebsite() {
  window.location.href = "https://www.google.com";
}


/* Comment Out Original function and insert redirect above */

/*
function closeWebsite(){
  if(isinserted == 0){
  var html = '<p>You must be over 18 to use the Tobacco Market Website!</p>';
    jQuery('.popup-newsletter').find('p').hide();
    jQuery( html ).insertAfter(jQuery('.popup-newsletter__title'));
    isinserted = 1;
    jQuery('.popup-newsletter__title').hide(); 
    localStorage.setItem('popuptime', 0);
       jQuery('body').addClass('inactive');
  }
}
*/



function onLoginButtonClick(){
  var loginProcess = sessionStorage.getItem('login');
  console.log(loginProcess);
  if(window.location.href != "https://tobaccomarket.com.au/challenge"){
  if(loginProcess != null){
      //check if user logged in
    if(jQuery('.header__action-item--account').find('.popover__linklist').length > 0){
      
       var referral = sessionStorage.getItem('location');
      if(loginProcess == 1)
      	dataLayer.push({'event': 'login', category: 'user login', 'action': referral});  
      else if(loginProcess == 2)
        dataLayer.push({'event': 'signup', category: 'user login', 'action': referral});  

        sessionStorage.removeItem('login');
      console.log(dataLayer);
         
    }
         
  }
  }
  jQuery('.form__submit').click(function(){
    if($(this).text() == "Login")
       sessionStorage.setItem('login', 1);
    else if($(this).text() == "Create my account"){
       sessionStorage.setItem('login', 2);
      console.log(sessionStorage.getItem('login'));
    }
     sessionStorage.setItem('location', window.location.href);
    
  
  });
  
}



jQuery( document ).ready(function() {
     jQuery(document).on("mousedown", '.pw-app-section button', function(event) {
         if(jQuery('#rbz-zipcode').val() != ""){
             dataLayer.push({'event': 'check postcode',  category: 'check postcode', 'label': jQuery('#rbz-zipcode').val()}); 
         }
    }); 
  
  var shepraHtml = "";
  var isShepra = false;
  jQuery(".template-cart").bind("DOMSubtreeModified", function(mutations) {

    if(mutations.target.className == "sherpa-wrapper"){
        shepraHtml = mutations.target; 
       isShepra = true;
    }
    
     if(jQuery(".card__section form").find('.sherpa-wrapper').length == 0 && isShepra==true){
      jQuery(".card__section form").prepend(shepraHtml);
     }
     
  });
addHealthBanner();

    //additional sherpa
  document.addEventListener('mincart:checkout-button-added', function(event) {
    if (jQuery('[name="checkout"]').hasClass('disabled')) {
       jQuery('[name="checkout"]').prop('disabled',true);
    } else {
       jQuery('[name="checkout"]').prop('disabled',false);
    }
  });
  document.addEventListener('theme:loading:end', function(event) {
    console.log('reload sherpa');
    SherpaApp.runSherpa(jQuery);
  });
  //end additional sherpa
  
});



function addHealthBanner(){
  console.log('healthBannerAdded');
  setTimeout(function(){
  /* jQuery('.announcement-bar__inner').html('<img src="https://cdn.shopify.com/s/files/1/0267/7286/5070/files/health-warning-footer-500x70-01-min.png" width="394.5px" height="55px">'); */
  /* jQuery('.announcement-bar__inner').html('<img src="https://cdn.shopify.com/s/files/1/0267/7286/5070/files/Tobacco_Online_Warning_-_1_April_to_30_June.png" width="394px" height="55px">');  */
  jQuery('#shopify-section-announcement-bar').html('<center><img src="https://cdn.shopify.com/s/files/1/0267/7286/5070/files/zzz.png" width="430px" height="55px"></center>');
  jQuery('#shopify-section-text-with-icons').find('.text-with-icons__content-wrapper').html('<img src="https://cdn.shopify.com/s/files/1/0267/7286/5070/files/health-warning-footer-500x70-01-min.png" alt="It is illegal to sell tobacco to a person under 18. It is illegal to purchase tobacco products for use by a person under 18. Quitting can improve your health." height="55px" width="394px" style="height: 55px !important;">');
  jQuery('.footer__block-item--text').html('<img src="https://cdn.shopify.com/s/files/1/0267/7286/5070/files/StandAlone_Cobranded_TobaccoMarket_Black_-min.png" alt="Powered by CTC" width="200px" height="37px">');
  jQuery('.header__logo-link').html('<img class="header__logo-image" src="//cdn.shopify.com/s/files/1/0267/7286/5070/files/MainLogo_TobaccoMarket_White_1_200x.png?v=1590992607" srcset="//cdn.shopify.com/s/files/1/0267/7286/5070/files/MainLogo_TobaccoMarket_White_1_200x.png?v=1590992607 1x, //cdn.shopify.com/s/files/1/0267/7286/5070/files/MainLogo_TobaccoMarket_White_1_200x@2x.png?v=1590992607 2x" alt="Tobacco Market." width="200px" height="67px">')
    
  
  }, 500);
}





